import { Button, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { Edit, DeviceAnalytics, Currency } from 'tabler-icons-react';
import { useNavigate } from 'react-router-dom';

export const useCompanyListColumns = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return [
    {
      key: 'name',
      dataIndex: 'name',
      title: t('companies.name'),
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      key: 'tax_id',
      dataIndex: 'tax_id',
      title: t('companies.tax_id'),
    },
    {
      key: 'address',
      dataIndex: 'address',
      title: t('companies.address'),
    },
    {
      key: 'city',
      dataIndex: 'city',
      title: t('companies.city'),
    },
    {
      key: 'country',
      dataIndex: 'country',
      title: t('companies.country'),
    },
    {
      key: 'files_analyzed',
      dataIndex: 'files_analyzed',
      title: 'Liczba plików',
      sorter: (a, b) => a.files_analyzed - b.files_analyzed,
    },
    {
      key: 'wcoxmlweb_analyzed',
      dataIndex: 'wcoxmlweb_analyzed',
      title: 'Liczba WcoWeb',
      sorter: (a, b) => a.wcoxmlweb_analyzed - b.wcoxmlweb_analyzed,
    },
    {
      key: 'actionColumn',
      title: '',
      align: 'center',
      render: row => (
        <Space size={2}>
          <Button type='link' onClick={() => navigate(`/front/companies/${row._id}`)}>
            <Edit />
          </Button>
          <Button type='link' onClick={() => navigate(`/front/companies/${row._id}/analytics`)}>
            <DeviceAnalytics />
          </Button>
          <Button type='link' onClick={() => navigate(`/front/companies/${row._id}/wcoxml-web`)}>
            <Currency />
          </Button>
        </Space>
      ),
    },
  ];
};
